{
  "customer_search_select": {
    "search_placeholder": "Search by name or email",
    "no_options": "No matching customers"
  }
}
